import { BillingPlanDto } from './billing-plan.dto';
import { BillingProductDto } from './billing-product.dto';
import { CustomerLeadDto } from './customer-lead.dto';

export class CustomerLeadProductDto {
  id?: number;
  billingPlanId?: number;
  customerLeadId?: number;
  billingProductId?: number;
  billingPlan?: BillingPlanDto;
  customerLead?: CustomerLeadDto;
  billingProduct?: BillingProductDto;
}
